require('/ui/components/entitypicker/entitylist/itemlist.module.scss.module.css');

export const item = "_item_1ql20_1";
export const icon = "_icon_1ql20_1";
export const customIcon = "_custom-icon_1ql20_1";
export const smallViewportSupport = "_small-viewport-support_1ql20_1";
export const entityItem = "_entity-item_1ql20_1";
export const entityLabels = "_entity-labels_1ql20_1";
export const label = "_label_1ql20_1";
export const sublabel = "_sublabel_1ql20_1";
export const collapsibleItem = "_collapsible-item_1ql20_1";
export const itemLabel = "_item-label_1ql20_1";
export const collapsibleContainer = "_collapsible-container_1ql20_1";
export const children = "_children_1ql20_1";
export const seeMoreItem = "_see-more-item_1ql20_1";
export const entityTypeHeader = "_entity-type-header_1ql20_1";
export const rightControls = "_right-controls_1ql20_1";
export const noResultsMessage = "_no-results-message_1ql20_1";
export const collapsed = "_collapsed_1ql20_1";
export const entityFlatList = "_entity-flat-list_1ql20_1";
